/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Lisää tilaukseen",
  "i18n.additionalProducts.emotionalHook": "♥️ Suosittu:",
  "i18n.additionalProducts.productDescription": "Tuote",
  "i18n.additionalProducts.showMore": "Lisätietoa",
  "i18n.additionalProducts.title": "Tarvikkeet",
  "i18n.button.addToCart": "Lisää ostoskoriin",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Käytä",
  "i18n.button.back": "Takaisin",
  "i18n.button.cancel": "Peruuta",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Sulje",
  "i18n.button.continue": "Jatka",
  "i18n.button.ignore": "Ohita",
  "i18n.button.ignoreAndContinue": "Jatka silti",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Teksti",
  "i18n.button.noChanges": "Ei kiitos, sulje ikkuna",
  "i18n.button.design": "",
  "i18n.button.photos": "Valokuvat",
  "i18n.button.retry": "Yritä uudelleen",
  "i18n.button.uploadPhotos": "Lataa valokuva(t)",
  "i18n.button.withSmartSorted": "Valitse SMART SORTED ",
  "i18n.button.withoutSmartSorted": "Ei kiitos, sulje ikkuna",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.actionBar.duplicate": "",
  "i18n.control.actionBar.editText": "",
  "i18n.control.actionBar.leaveTextEditing": "",
  "i18n.control.actionBar.delete": "",
  "i18n.control.actionBar.rotate": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Paranna luettavuutta lyhentämällä tekstiä / riviä.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Valittu fontti on liian suuri tälle tekstille.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Tälle tekstille ei voi valita suurempaa fonttikokoa.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Tälle tekstille ei voi valita pienempää fonttikokoa.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Lisää rivinvaihto",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Jatka kirjoittamista toisella rivillä tai suurenna tekstikenttää.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Tarkista teksti, kaikki fontit eivät tue tätä fonttia.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Paranna luettavuutta lyhentämällä tekstiä / riviä.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Suurenna tekstikenttää",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Tätä toimintoa ei voi peruuttaa",
  "i18n.dialog.deletePlaceholder.title": "Haluatko varmasti poistaa paikkamerkin?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Tämän kuvan resoluutio on liian alhainen, joten painetun kuvan laatu ei ole optimaalinen!",
  "i18n.dialog.smartSorted.message": "Innovatiivinen SMART SORTED helpottaa 1 000 palan palapelin kokoamista jopa ilman mallikuvaa.",
  "i18n.dialog.smartSorted.title": "Onnistumisen hetket taattu",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klikkaamalla  \"{{text}}\" voit muuttaa laatikon otsikkoa.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Laatikon otsikkoa ei ole muutettu",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Jatka ilman laatikon otsikkoa",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Paikkamerkkiä ei ole muutettu",
    "Paikkamerkkejä ei ole muutettu."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "muuttamattomat paikkamerkit",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Suunnitteluprosessi keskeytetty",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Valokuvaa ei voitu ladata.  Se on poistettu suunnittelualueelta ja valikoimasta.",
  "i18n.error.imageLoadingError.title": "Virhe palvelimelta ladattaessa",
  "i18n.error.imageProvisionError.message": "Yhtä tai useampaa valokuvaa ei voitu käsitellä. Todennäköisesti mediatyyppiä ei tueta",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Tiedostoa \"{{reference1}}\" ei voitu käsitellä.",
  "i18n.error.imageSelectionError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.imageSizeLimitExceededError.message": "Lataamasi kuva on liian suuri.\nPienennä kuvaa niin, että kuva on korkeintaan 180 megapikseliä, ja lataa kuva uudelleen.",
  "i18n.error.imageSizeLimitExceededError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.imageUploadError.message": "Internetyhteydessä on tapahtunut virhe.\nYritä myöhemmin uudelleen.",
  "i18n.error.imageUploadError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Tämä fontti ei ole käytettävissä, valitse toinen fontti.",
  "i18n.error.invalidCharConfigError.title": "Fontti ei ole käytettävissä",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Internetyhteytesi on ilmeisesti katkennut. Voit jatkaa tuotteesi suunnittelua heti kun yhteys taas toimii.",
  "i18n.error.templateLoadingError.message": "Mallipohjaa \"{{ error.reference[0] }}\" ei voitu ladata.\nYritä myöhemmin uudelleen.",
  "i18n.error.templateLoadingError.title": "Virhe palvelimelta ladattaessa",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" mediatyyppiä ei tueta.",
  "i18n.error.unsupportedMediaTypeError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.uploadProductError.message": "Yhtä tai useampaa tuotetta ei voitu siirtää palvelimelle.\nYritä myöhemmin uudelleen.",
  "i18n.error.uploadProductError.title": "Virhe tiedonsiirrossa",
  "i18n.error.zoomModeError.message": "Edellisen layoutisi tekstiä ei voitu käyttää. Syötä uusi teksti.",
  "i18n.error.zoomModeError.title": "Tekstiä ei voitu käyttää",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Hinta",
  "i18n.price.reduction": "Säästät ",
  "i18n.price.total": "Kokonaishinta",
  "i18n.priceDisplay.times": [
    "{{value}} kappale hintaan {{pricePerUnit}}",
    "{{value}} kappaletta hintaan {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Valitse tarvikkeet",
  "i18n.progressOverlay.message.lines.one": "Kiitos huolella suunnittelemastasi tuotteesta.",
  "i18n.progressOverlay.message.lines.two": "Valmistelemme juuri tilauksesi seuraavaa vaihetta…",
  "i18n.template.insertText": "Syötä teksti tähän",
  "i18n.toolbox.image.title": "Muokkaa valokuvaa",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 valokuva",
    "{{value}} valokuvaa"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D-esikatselu",
  "i18n.toolbox.productChooser.title": "Vaihda tuote",
  "i18n.toolbox.productChooser.triggerText": "Tuote",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Muokkaa tekstiä",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleFiFI {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
